import { render, staticRenderFns } from "./AutomationPermissionSettings.vue?vue&type=template&id=355fe9d4&scoped=true"
import script from "./AutomationPermissionSettings.vue?vue&type=script&lang=js"
export * from "./AutomationPermissionSettings.vue?vue&type=script&lang=js"
import style0 from "./AutomationPermissionSettings.vue?vue&type=style&index=0&id=355fe9d4&prod&scoped=true&lang=scss"
import style1 from "./AutomationPermissionSettings.vue?vue&type=style&index=1&id=355fe9d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355fe9d4",
  null
  
)

export default component.exports